import React from 'react';

import { Panel, PanelGroup } from 'react-resizable-panels';
import CustomResizeHandle from '@/app/components/CustomResizeHandle';
import BottomGrid from '../BottomGrid';
import ClientsAndLocationsGrid from '../ClientsAndLocationsGrid';
import {
    IFeatureSelectedOnGridParams,
    TVectorGeometrySource,
} from '../../types';
import { TGridTypes } from '@/app/state/ui/customerService/bottomGrid';
import { StyledGridContainerBox } from '@/app/components/CustomResizeHandle/CustomResizeHandle';

const DEFAULT_PANEL_SIZE = 50;
const MIN_PANEL_SIZE = 10;

interface IOwnProps {
    locationsSource: TVectorGeometrySource;
    selectedItems: { [key: string]: string[] };
    onFeatureSelected: (params: IFeatureSelectedOnGridParams) => void;
    lastSelectedLocation: string;
    handleSelectLastItem: (sourceSetId: string, lastItemId: string) => void;
    bottomGrid: TGridTypes | null;
    bottomGridSource: TVectorGeometrySource;
    lastSelectedBottomItem: string;
}
const GridSection = ({
    locationsSource,
    selectedItems,
    onFeatureSelected,
    lastSelectedLocation,
    handleSelectLastItem,
    bottomGrid,
    bottomGridSource,
    lastSelectedBottomItem,
}: IOwnProps) => (
    <PanelGroup direction="vertical" autoSaveId="customer-service-vertical">
        <Panel defaultSize={DEFAULT_PANEL_SIZE} minSize={MIN_PANEL_SIZE}>
            <StyledGridContainerBox>
                <ClientsAndLocationsGrid
                    selectedItems={selectedItems}
                    onFeatureSelected={onFeatureSelected}
                    source={locationsSource}
                    lastSelectedItem={lastSelectedLocation}
                    handleSelectLastItem={handleSelectLastItem}
                />
            </StyledGridContainerBox>
        </Panel>
        {bottomGrid && <CustomResizeHandle direction="vertical" />}
        {bottomGrid && (
            <Panel defaultSize={DEFAULT_PANEL_SIZE} minSize={MIN_PANEL_SIZE}>
                <StyledGridContainerBox>
                    <BottomGrid
                        onFeatureSelected={onFeatureSelected}
                        lastSelectedBottomItem={lastSelectedBottomItem}
                        source={bottomGridSource}
                        selectedItems={selectedItems}
                        handleSelectLastItem={handleSelectLastItem}
                    />
                </StyledGridContainerBox>
            </Panel>
        )}
    </PanelGroup>
);

export default GridSection;
